export default {
  head: {
    ClientAdmin: 'Guản lý merchant',
    ClientLIst: 'Danh sách merchant'
  },
  table: {
    addClient: 'Thêm merchant',
    agentAccount: 'Tài khoản đại lý',
    GeneralAgent: 'Tổng đại lý',
    merchantModel: 'Phương thức',
    merchantName: 'Tài  khoản merchant',
    merchantPhone: 'Số điện thoại',
    merchantNo: 'Tài khoản merchant',
    merchantResources: 'Nguồn merchant',
    merchantType: 'Loại merchant',
    merchantStatus: 'Trạng thái merchant',
    operaTion: 'Thao tác',
    changemessage: 'Sửa',
    checkmessage: 'Xem ',
    payoutQueryUrl: 'Địa chỉ tra cứu thanh toán',
    payoutQueryStatus: 'Trạng thái yêu cầu thanh toán',
    merchantEmail: 'Merchant email'
  },
  addDialog: {
    addmerchant: 'Thêm merchant',
    userPass: 'Mật khẩu đăng nhập',
    payPass: 'Trả chìa khóa',
    googleCode: 'Khóa google',
    googleQrCode: 'Mã QR của Google',
    phone: 'Số điện thoại',
    optionModtext1: 'Hội viên chịu phí',
    optionModtext2: 'Merchant chịu phí',
    optionRestext1: 'Chúng tôi cung cấp',
    optionRestext2: 'Merchant cung cấp',
    optionTypetext1: 'Tổng đại lý',
    optionTypetext2: ' đại lý',
    optionTypetext3: 'Merchant',
    optionWithdratext1: 'Tỉ lệ  rút tiền',
    optionWithdratext2: 'Phí cố định',
    placeholdertext: 'Vui lòng nhập nội dung',
    placeholderName: 'Vui lòng nhập tên merchant',
    selectModel: 'Chọn phương thức merchant',
    selectResour: 'Chọn nguồn merchant',
    selectType: 'Chọn loại merchant',
    payoutType: 'Loại thanh toán',
    normalPayout: 'Thanh toan tự động',
    specialPayout: 'Thanh toán thủ công',
    resetGoogleCode: 'đặt lại khóa google',
    orderPrefix: 'Tiền tố đặt hàng của người bán',
    unlock: 'Mở khóa',
    payoutCheckType: 'Loại yêu cầu hoàn trả thanh toán',
    payoutCheckService: 'Dịch vụ yêu cầu hoàn trả thanh toán'
  },
  updataDia: {
    updatamerchantModel: 'Sửa phương thức merchant',
    updatamerchantResources: 'Sửa đổi tài nguyên merchant',
    updatamerchantType: 'Sửa đổi loại  merchant',
    updatamerchantWithdrawalType: 'Sửa đổi tỉ lệ thu phí merchant',
    wallet: 'Loại ví tiền',
    card: 'Phí thẻ cào',
    merchantWithdrawalFee: 'Phí rút tiền',
    merchantWithdrawalType: 'Phí merchant rút tiền',
    momo: 'Phí ví Momo',
    momoIpay: 'Phí momo doanh nghiệp',
    onlineBankingDirectConnect: 'Phí chuyển khoản ngân hàng',
    onlineBankingQr: 'Phí banking QR',
    payOnBehalfOf: 'Phí payout',
    viettelpay: 'Phí viettelpay',
    zalo: 'Phí zalopay',
    vipQr: 'Phí ví QRTOP',
    usdt: 'Phí ví USDT',
    checkName: 'Tài khoản merchant không được để trống',
    payoutFixedFee: 'Phí thanh toán cố định',
    momoBank: 'Phí xử lý MomoBank',
    zaloBank: 'Phí của zaloBank',
    vtpBank: 'Phí vtpBank'
  },

  label: {
    card: 'Phí thẻ cào',
    merchantWithdrawalFee: 'Phí rút tiền',
    momo: 'Phí ví Momo',
    momoIpay: 'Phí cung ứng ví Momo',
    onlineBankingDirectConnect: 'Phí chuyển khoản ngân hàng',
    onlineBankingQr: 'Phí  kết nối mã Qr',
    payOnBehalfOf: 'Phí bên thứ 3',
    viettelpay: 'Phí Viettelpay',
    zalo: 'Phí Zalopay',
    usdt: 'Phí sử dụng USDT',
    vipQr: 'Phí ví QRTop',
    payoutFixedFee: 'Phí thanh toán cố định',
    momoBank: 'Phí xử lý MomoBank',
    zaloBank: 'Phí của zaloBank',
    vtpBank: 'Phí vtpBank'
  },

  placeholder: {
    card: 'Vui lòng nhập Phí thẻ cào',
    merchantWithdrawalFee: 'Vui lòng nhập Phí rút tiền',
    momo: 'Vui lòng nhập Phí ví Momo',
    momoIpay: 'Vui lòng nhập Phí cung ứng ví Momo',
    onlineBankingDirectConnect: 'Vui lòng nhập Phí Internet Banking',
    onlineBankingQr: 'Vui lòng nhập Phí  kết nối mã Qr',
    payOnBehalfOf: 'Vui lòng nhập Phí bên thứ 3',
    viettelpay: 'Vui lòng nhập Phí Viettelpay',
    zalo: 'Vui lòng nhập Phí Zalopay',
    usdt: 'Vui lòng nhập Phí sử dụng USDT',
    vipQr: 'Vui lòng nhập Phí ví QRTop',
    payoutFixedFee: 'Vui lòng nhập phí cố định để thanh toán',
    momoBank: 'Vui lòng nhập phí xử lý momoBank',
    zaloBank: 'Vui lòng nhập phí xử lý zaloBank ',
    vtpBank: 'Vui lòng nhập phí xử lý vtpBank '
  },

  rules: {
    payoutQueryStatus: {
      required: 'Trạng thái truy vấn thanh toán phải được chọn'
    },
    merchantType: {
      required: 'loại merchant bắt buộc chọn'
    },
    agentAcct: {
      required: 'bắt buộc chọn đại lý'
    },
    merchantModel: {
      required: 'phương thức bắt buộc chọn'
    },
    merchantResources: {
      required: 'nguồn merchant bắt buộc chọn'
    },
    merchantWithdrawalType: {
      required: 'phí bắt buộc chọn'
    },
    payPass: {
      required: 'mật khẩu thanh toán không được để trống',
      between: 'mất khẩu thanh toán bắt buộc từ 6 đến 20 kí tự'
    },

    card: {
      required: 'phí thẻ cào không được để trống',
      type: 'phí thẻ cào bắt buộc là định dạng số',
      min: 'phí phải lớn hơn 0',
      max: ' thẻ cào phải nhỏ hơn hoặc bằng 100',
      float: 'phí thẻ cào nhiều nhất định dạng 2 số'
    },
    merchantWithdrawalFee: {
      required: 'phí rút tiền không được bỏ trống',
      type: 'phí rút tiền bắt buộc định dạng số',
      max: ' phí rút tiền phải nhỏ hơn hoặc bằng 100',

      min: 'phí rút tiền bắt buộc phải lớn hơn 0',
      float: 'phí rút tiền nhiều nhất định dạng 2 số'
    },
    momo: {
      required: 'phí momo không được bỏ trống',
      type: 'phí momo phải là định dạng số',
      min: 'phí momo phải lớn hơn 0',
      max: 'phí momo phải nhỏ hơn hoặc bằng 100',

      float: 'phí momo nhiều nhất định dạng 2 số'
    },
    momoIpay: {
      required: 'phí momo không được bỏ trống',
      type: 'phí momo phải là định dạng số',
      min: 'momo phí momo phải lớn hơn 0',
      max: 'phí momo doang nhiệp phải nhỏ hơn hoặc bằng 100',

      float: 'phí momo nhiều nhất định dạng 2 số'
    },
    onlineBankingDirectConnect: {
      required: 'phí online banking không được bỏ trống',
      type: 'phí online banking phải là định dạng số',
      min: 'phí online banking phải lớn hơn 0',
      max: '100 phí online banking phải nhỏ hơn hoặc bằng 100',

      float: 'phí online banking nhiều nhất định dạng 2 số'
    },
    onlineBankingQr: {
      required: 'phí bankqr không được bỏ trống',
      type: 'phí bankqr phải là định dạng số',
      max: '100 phí bank qr phải nhỏ hơn hoặc bằng 100',

      min: 'phí bankqr phải lớn hơn 0',
      float: 'phí bankqr nhiều nhất định dạng 2 số'
    },
    qrPro: {
      required: 'Phí xử lý cá nhân qrPro không được để trống',
      type: 'Phí xử lý cá nhân qrPro phải là một con số',
      min: 'Phí xử lý cá nhân qrPro phải lớn hơn 0',
      max: 'Phí xử lý cá nhân qrPro phải nhỏ hơn hoặc bằng 100',
      float: 'Phí xử lý cá nhân qrPro có thể có tối đa hai chữ số thập phân.'
    },
    payOnBehalfOf: {
      required: 'phí payout không được bỏ trống',
      type: 'phí payout phải là định dạng số',
      min: 'phí payout phải lớn hơn 0',
      max: 'phí payout phải nhỏ hơn hoặc bằng 100',

      float: 'phí payout nhiều nhất định dạng 2 số'
    },
    viettelpay: {
      required: 'phí viettelpay không được bỏ trống',
      type: 'phí viettelpay phải là định dạng số',
      min: 'phí viettelpay phải lớn hơn 0',
      max: 'phí viettepay phải nhỏ hơn hoặc bằng 100',

      float: 'phí viettelpay nhiều nhất định dạng 2 số'
    },
    zalo: {
      required: 'phí zalo không được bỏ trống',
      type: 'phí zalo định dạng số',
      min: 'phí zalo phải lớn hơn 0',
      max: 'phí zalopay phải nhỏ hơn hoặc bằng 100',
      float: 'phí zalo nhiều nhất định dạng 2 số'
    },
    usdt: {
      required: 'phí usdt không được bỏ trống',
      type: 'phí usdt định dạng số',
      min: 'phí usdt phải lớn hơn 0',
      max: 'phí usdt phải nhỏ hơn hoặc bằng 100',
      float: 'phí usdt nhiều nhất định dạng 2 số'
    },
    payoutFixedFee: {
      required: 'Thanh toán phí cố định không được để trống'
    },
    qrPro: {
      required: 'phí qrPro không được bỏ trống',
      type: 'phí qrPro định dạng số',
      min: 'phí qrPro phải lớn hơn 0',
      max: 'phí qrPro phải nhỏ hơn hoặc bằng 100',
      float: 'phí qrPro nhiều nhất định dạng 2 số'
    },
    momoBank: {
      required: 'phí momoBank không được bỏ trống',
      type: 'phí momoBank định dạng số',
      min: 'phí momoBank phải lớn hơn 0',
      max: 'phí momoBank phải nhỏ hơn hoặc bằng 100',
      float: 'phí momoBank nhiều nhất định dạng 2 số'
    },
    zaloBank: {
      required: 'phí zaloBank không được bỏ trống',
      type: 'phí zaloBank định dạng số',
      min: 'phí zaloBank phải lớn hơn 0',
      max: 'phí zaloBank phải nhỏ hơn hoặc bằng 100',
      float: 'phí zaloBank nhiều nhất định dạng 2 số'
    },
    vtpBank: {
      required: 'phí vtpBank không được bỏ trống',
      type: 'phí vtpBank định dạng số',
      min: 'phí vtpBank phải lớn hơn 0',
      max: 'phí vtpBank phải nhỏ hơn hoặc bằng 100',
      float: 'phí vtpBank nhiều nhất định dạng 2 số'
    }
  },
  Minimum_safety_limit_for_merchant_payment: 'Giới hạn thanh toán thấp nhất',
  Please_enter_the_minimum_security_limit_for_merchant_payment:
    'Vui lòng nhập Giới hạn thanh toán thấp nhất',
  Payment_warning_group_id: 'ID cảnh báo nhóm thanh toán',
  Please_enter_the_payment_warning_group_id: 'id Vui lòng nhập ID cảnh báo nhóm thanh toán',
  Merchant_Withdrawal_Minimum_Security_Limit: 'Giới hạn bảo mật tối thiểu rút tiền của người bán',
  Please_enter_the_merchant_minimum_security_limit_for_withdrawals:
    'Vui lòng nhập giới hạn rút tiền an toàn tối thiểu của người bán',
  Withdrawal_warning_group_ID: 'ID nhóm cảnh báo rút tiền',
  Please_enter_the_withdrawal_warning_group_ID: 'Vui lòng nhập ID nhóm cảnh báo rút tiền',
  CannotEmpty: 'Không thể để trống',
  验证码限制: 'Vui lòng nhập mã xác minh gồm 6 chữ số'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/clientmanage.js